import { render, staticRenderFns } from "./lavorazioni.vue?vue&type=template&id=bf1387d4&scoped=true&"
import script from "./lavorazioni.vue?vue&type=script&lang=js&"
export * from "./lavorazioni.vue?vue&type=script&lang=js&"
import style0 from "./lavorazioni.vue?vue&type=style&index=0&id=bf1387d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1387d4",
  null
  
)

export default component.exports